import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Auth } from '@core/auth/services/auth';
import { MessageService } from 'primeng/api';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const messageSvc = inject(MessageService);
  const authSvc = inject(Auth);
  return next(req).pipe(
    catchError((err) => {
      const status = err.status;
      if (status === 401) {
        messageSvc.add({ severity: 'error', summary: 'Error', detail: err.error?.message, life: 5000 });
        authSvc.clearSession()
      } else if ([400, 404, 403, 419, 422, 429, 500].includes(status)) {
        messageSvc.add({ severity: 'error', summary: 'Error', detail: err.error?.message, life: 5000 });
      }
      return throwError(() => err);
    })
  );
};
